import React, { useState, useContext, useEffect } from "react";
import { Navbar } from "reactstrap";
// import Logo_nFiniti from "./Logo_nFiniti.svg";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Avatar from "react-avatar";
import InfinityHeaderLogo from "../../images/InfinityHeaderLogo.svg";
import { ReactComponent as Feedback } from "../../images/Feedback.svg";
import { ReactComponent as Notifications } from "../../images/Notifications.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMailReply, faUsersGear } from "@fortawesome/free-solid-svg-icons";
import "./navigation.scss";
import { BankUserContext } from "../../bankUserContext";
import { IOrgProductModel } from "../../models/SharedModel";
import { TrackersEnum } from "../../models/TrackerModel";
import { APP_Config } from "../../utils/AppConfig";
import Logo from "../../images/NoLogo.svg";
import Combined from "../../images/CombinedD.svg";
import { clearFilters } from "../Filters/FiltersHelper";
import { Modal, ModalHeader, ModalFooter } from "reactstrap";
import NotificationsRC from "./Leads/Notifications/NotificationsRC";
import { NotificationModel } from "./Leads/Notifications/NotificationModal";
import moment from "moment";
import CombinedShape from './../../images/CombinedShape.svg'
import Service from "../../services";
import { AxiosError, AxiosResponse } from "axios";
import { catchError } from "../../utils/Utils";

interface HeaderProps {
  LogoData: any;
  productRedirection?: (
    value: IOrgProductModel,
    trackerType?: TrackersEnum | string
  ) => void;
  showProductsHeader?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  LogoData,
  productRedirection,
  showProductsHeader,
}) => {
  const { selectedProduct, orgProductsList } = useContext(BankUserContext);
  const bankUserContext = useContext(BankUserContext);

  const location = useLocation();
  const navigate = useNavigate();
  const [userShow, setUserShow] = useState(false);
  const [showNavigation, setShowNavigation] = useState(true);
  const [confirmFeedBack, setConfirmFeedBack] = useState<boolean>(false);
  const [feedbackFormFlag, setFeedbackFormFlag] = useState<boolean>(false);
  const [productsDropdown, setProductsDropdown] = useState<boolean>(false);
  const [notificationModal, setNotificationModal] = useState<boolean>(false);
  const [notifications, setNotifications] = useState([])
  const service = new Service();

  const avatarUserHandler = () => {
    setUserShow(!userShow);
  };
  const projectPath = useLocation();

  const productsToggle = () => setProductsDropdown((prev) => !prev);
  const handleMouseLeave = () => {
    setProductsDropdown(false);
  };
  const handleMouseEnter = () => {
    setProductsDropdown(true);
  };
  const logoutBtn = () => {
    const accesstoken = localStorage.getItem("token");
    const refreshToken = localStorage.getItem("refreshToken");
    const userId = bankUserContext?.bankuserDetails?.userId;
    window.location.href = `${APP_Config().REACT_APP_LOGOUT
      }?accesstoken=${accesstoken}&refreshtoken=${refreshToken}&clientId=${APP_Config().REACT_APP_CLIENT_ID
      }&sessionExpired=${false}&userId=${userId}`;
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.clear();
    clearFilters();
  };

  const logoutbtn = () => {
    const accesstoken = localStorage.getItem("token");
    const refreshToken = localStorage.getItem("refreshToken");
    const userId = bankUserContext?.bankuserDetails?.userId;

    const data = {
      accessToken: accesstoken,
      refreshToken: refreshToken,
      clientId: APP_Config().REACT_APP_CLIENT_ID,
      sessionExpired: false,
      userId:userId
    }
    service
      .logOut(data)
      .then((response: AxiosResponse<any>) => {
        logoutBtn()


      })
      .catch((error: AxiosError) => {
        catchError(error, true);

      });
  }

  const flagModalViewHandler = () => {
    setFeedbackFormFlag(!feedbackFormFlag);
  };

  const toggleNotificationModal = () => {
    setNotificationModal((pre) => (!pre))
  }

  const notificationTile = (element: NotificationModel, index: number) => (
    <div key={index}>
      {/* <div 
        // className={this.roles.isSuperUser(this.context?.bankuserDetails?.roles)? "notificationWrapper disable" :
        // `notificationWrapper ${element?.read ? "" : "unread"}`} 
        onClick={() =>handleNotificationClick(element)}
      >
        <div className={!element?.read ? "oval" : "noOval"}></div>
        <div className="notificationsElement">
          <div className="left">
            <div className="text1">
              { element?.message ? "New Message" : "New Task in To Do’s"}
            </div>
            <div className="text2">
              {
                element?.message ? messageSecondLine(element) : todoSecondLine(element)
              }
            </div>{" "}
            <div className="text3">
              {element?.notification}
            </div>{" "}
          </div>
          <div className="right">
            <div className="time">{element?.createdAt ? moment(element.createdAt).fromNow() : "--"}</div>
            <div className="notificationOption">
              <Dropdown 
                className="img" 
                toggle={(e: any) => { e.stopPropagation(); setIsOpen(index); }}
                isOpen={index == myTodoToggle}
              >
                <DropdownToggle>
                <img className='combinedShape' src={CombinedShape}  alt="nothing" />
                </DropdownToggle>
                <DropdownMenu className="notificationsMenuInner footerOptions">
                  <DropdownItem onClick={(e: any) => readNotification(element, e)}>
                    { element?.read ? "Mark as Unread" : "Mark as Read" }
                  </DropdownItem>
                  <DropdownItem onClick={(e: any) => deleteNotification(element, e)}>
                    Delete
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div> */}
      <div className={`${index === notifications?.length - 1 ? "" : "line"}`}></div>
    </div>
  )

  // const confirmFeedBackModel = () => {
  //   setConfirmFeedBack(!confirmFeedBack);
  // };

  // const submitFeedback = (body:any) =>{
  //   const data = {
  //     topic:body.FeedbackFormTopic,
  //     message:body.Comments,
  //     toEmail:"fin420.feedback@FinResults.com",
  //     company:""
  //   }
  //   setLoader(true);
  //   service.getFeedback(data).then((response:any)=>{
  //     console.log(response)
  //     setFeedbackFormFlag(!feedbackFormFlag)
  //     //toast.success("Feedback Sent")
  //     setFeedbackMessage(response.data)
  //     confirmFeedBackModel()
  //   }).catch((error:any)=>{
  //     catchError(error,true);
  //     setFeedbackFormFlag(!feedbackFormFlag)
  //   }).finally(()=>{
  //     setLoader(false);
  //   })
  // }

  return (
    <>
      {/* <Modal
        className="confirm-feedback-modal"
        isOpen={confirmFeedBack}
        fade={false}
        toggle={confirmFeedBack}
      >
        <ModalHeader toggle={confirmFeedBackModel}>
          <div>
            <p className="modalHeading">{feedbackMessage}</p>
          </div>
          <Button onClick={() => confirmFeedBackModel()}>OK</Button>
        </ModalHeader>
      </Modal> */}
      {/* {loader ? (
        <SpinnerModel value={""} color={"primary"} size={""} type={"border"} />
      ) : (
        <Modal
          className="feedback-modal"
          isOpen={feedbackFormFlag}
          fade={false}
          toggle={feedbackFormFlag}
        >
          <ModalHeader toggle={flagModalViewHandler}>
            <div>
              <p className="modalHeading">Product Improvement Feedback</p>
            </div>
          </ModalHeader>
          <ModalBody className="feedback-modal-container">
            <FeedbackForm submitFeedback={submitFeedback} />
          </ModalBody>
        </Modal>
      )} */}
      {/* {logout && <Redirect to="/login" />} */}
      {showNavigation && (
        <>
          <Navbar className="topNavBar" expand="md">
            <div className="flex-1">
              <img
                src={
                  LogoData.find((item: any) => item.iconkey === "headerIcon")
                    ?.logopath || Logo
                }
                onClick={()=>navigate('/landing')}
                className="headerLogo"
                alt="logo"
              />
            </div>
            {!projectPath?.pathname?.includes("landing") ? (
              <div
                className="feedback-wrap"
                onClick={() => {
                  flagModalViewHandler();
                }}
              >
                <Feedback />
                <span>FEEDBACK</span>
              </div>
            ) : (
              <img src={Combined} alt="Combined" />
            )}

            <div className="notofication-wrap">
              <NotificationsRC />
            </div>


            <div className="profile-wrap">
              <Dropdown
                toggle={() => avatarUserHandler()}
                isOpen={userShow}
                className="userdropDown"
              >
                <DropdownToggle className="avathar-btn">
                  <Avatar
                  size="38px"
                  maxInitials={2}
                  textSizeRatio={2}
                  textMarginRatio={0.2}
                  round
                  name={
                    bankUserContext?.bankuserDetails?.firstName +
                    " " +
                    bankUserContext?.bankuserDetails?.lastName
                  }
                />
                </DropdownToggle>
                <DropdownMenu right>
                  <div className="notificationsmodalbody">
                    <div className="notificationWrapper">
                      {/* <DropdownItem
                  // tag="a" href={`/Settings/ChangePasswordUser/`} 
                  >Settings &amp; Preferences</DropdownItem> */}
                      <DropdownItem tag="a" href={`/settings`}>
                        Change Password
                      </DropdownItem>
                      <DropdownItem onClick={logoutbtn}>Log Out</DropdownItem>
                    </div>
                  </div>
                </DropdownMenu>
              </Dropdown>
            </div>
          </Navbar>
          {showProductsHeader &&
            selectedProduct &&
            orgProductsList?.length > 0 ? (
            <div className="productsHeader">
              <Dropdown
                isOpen={productsDropdown}
                toggle={productsToggle}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <DropdownToggle caret>
                  {(selectedProduct?.productName+" "+"Tracker").length > 25 ?
                   `${(selectedProduct?.productName+" "+"Tracker").slice(0, 25)}...` : (selectedProduct?.productName+" "+"Tracker")|| ""} 
                </DropdownToggle>
                <DropdownMenu>
                  {orgProductsList && orgProductsList?.length > 0 ? (
                    orgProductsList?.map((each) => (
                      <DropdownItem
                        onClick={() =>
                          productRedirection &&
                          productRedirection(
                            each,
                            location?.pathname?.split("/")?.[2]
                          )
                        }
                      >
                        {each?.productName} Tracker
                      </DropdownItem>
                    ))
                  ) : (
                    <></>
                  )}
                </DropdownMenu>
              </Dropdown>
            </div>
          ) : (
            <></>
          )}
        </>
      )}

    </>
  );
};

export default Header;
